import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Order } from '../types/order.type';
import { ADMIN_ORDER_API_PATHS } from '../constants/orders-api-paths.constant';

type UseAdminGetOrderByIdResult = {
  isLoading: boolean;
  order: Order | null;
};

export function useAdminGetOrderById(orderId: string): UseAdminGetOrderByIdResult {
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState<UseAdminGetOrderByIdResult>({ isLoading: true, order: null });

  useEffect(() => {
    let cancelled = false;

    HttpClient.get<Order>(ADMIN_ORDER_API_PATHS.GET_ORDER_BY_ID(orderId))
      .then((fetched) => {
        if (!cancelled) setState({ isLoading: false, order: fetched });
      })
      .catch((error) => {
        if (!cancelled) {
          enqueueSnackbar(
            extractApiErrorMessage(error, 'Erreur lors du chargement de la commande'),
            { variant: 'error' }
          );
          setState({ isLoading: false, order: null });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [orderId]);

  return state;
}
